import React from 'react';
import TodoBoard from '../TodoBoard';

export default function TodoModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div
      data-modal="todo"
      style={{
        position: 'fixed',
        top: 0,
        left: 320,
        right: 0,
        bottom: 0,
        width: 'calc(100vw - 320px)',
        height: '100vh',
        zIndex: 100003,
        display: 'flex',
        background: 'rgba(18, 8, 28, 0.72)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        pointerEvents: 'auto',
      }}
      onClick={onClose}
    >
      <div style={{ display: 'flex', width: '100%', minWidth: 0 }} onClick={e => e.stopPropagation()}>
        <TodoBoard onClose={onClose} />
      </div>
    </div>
  );
}
